<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (ballValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Ball Valve:</label>
              <select class="halfWidthInputField" #ballValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(ballValveSelection.Name)"
                (change)="selectionChanged(ballValveSelection, ballValveInput.value)"
                [value]="ballValveSelection.Value.toString()">
                @for (allowable of ballValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="ballValveSelection.Value && ballValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (electricHeaterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Electric Heater:</label>
              <select class="halfWidthInputField" #electricHeaterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(electricHeaterSelection.Name)"
                (change)="selectionChanged(electricHeaterSelection, electricHeaterInput.value)"
                [value]="electricHeaterSelection.Value.toString()">
                @for (allowable of electricHeaterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="electricHeaterSelection.Value && electricHeaterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (hoseKitsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Hose Kits:</label>
              <select class="halfWidthInputField" #hoseKitsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitsSelection.Name)"
                (change)="selectionChanged(hoseKitsSelection, hoseKitsInput.value)"
                [value]="hoseKitsSelection.Value.toString()">
                @for (allowable of hoseKitsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="hoseKitsSelection.Value && hoseKitsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (flowRateSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">GPM:</label>
              <select class="halfWidthInputField" #flowRateInput
                [class.invalidConfigurationSelection]="isInvalidSelection(flowRateSelection.Name)"
                (change)="selectionChanged(flowRateSelection, flowRateInput.value)"
                [value]="flowRateSelection.Value.toString()">
                @for (allowable of flowRateSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="flowRateSelection.Value && flowRateSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (replacementFiltersSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Replacement Filters:</label>
              <select class="halfWidthInputField" #replacementFiltersInput
                [class.invalidConfigurationSelection]="isInvalidSelection(replacementFiltersSelection.Name)"
                (change)="selectionChanged(replacementFiltersSelection, replacementFiltersInput.value)"
                [value]="replacementFiltersSelection.Value.toString()">
                @for (allowable of replacementFiltersSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="replacementFiltersSelection.Value && replacementFiltersSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (thermostatSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Thermostat:</label>
              <select class="halfWidthInputField" #thermostatInput
                [class.invalidConfigurationSelection]="isInvalidSelection(thermostatSelection.Name)"
                (change)="selectionChanged(thermostatSelection, thermostatInput.value)"
                [value]="thermostatSelection.Value.toString()">
                @for (allowable of thermostatSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="thermostatSelection.Value && thermostatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (drainPanSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Drain Pan:</label>
              <select class="halfWidthInputField" #drainPanInput
                [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
                (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
                [value]="drainPanSelection.Value.toString()">
                @for (allowable of drainPanSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (waterValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Water Valve:</label>
              <select class="halfWidthInputField" #waterValveInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterValveSelection.Name)"
                (change)="selectionChanged(waterValveSelection, waterValveInput.value)"
                [value]="waterValveSelection.Value.toString()">
                @for (allowable of waterValveSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="waterValveSelection.Value && waterValveSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
